<template>
    <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full capitalize"
          :class="getBadgeClass(role)">
        {{ role }}
    </span>
</template>

<script setup>
const props = defineProps({
    role: {
        type: String,
        required: true
    }
});

const { role } = props;

const getBadgeClass = (role) => {
    const classes = {
        'owner': 'bg-purple-100 text-purple-800',
        'admin': 'bg-blue-100 text-blue-800',
        'member': 'bg-gray-100 text-gray-800'
    };
    return classes[role] || 'bg-gray-100 text-gray-800';
};
</script>